<template>
  <a-modal
    class="m-monthly-plan-container"
    wrapClassName="m-monthly-plan"
    :visible="isShow"
    title="月額プランの変更"
    centered
    :maskClosable="false"
    :footer="null"
    @cancel="handleCloseModal"
  >
    <div class="m-plan-content">
      <div class="font-weight-bold mb-3 title-plan">{{ plan.plan_name }} に変更してもよろしいでしょうか？</div>
      <div class="desc-plan mb-3 p-3">
        <div class="note-plan">
          <span>■変更時のご注意事項 </span>
          <span>月額プランのサービス期間は、プラン変更日から1か月となります。</span>
          <span> フリープランから有料プランへ変更を行った場合、即時プランが変更されます。</span>
          <div class="note-different-paid">
            <span>有料プランから異なる有料プランへ変更を行った場合、</span>
            <span>元の有料プランのサービス期間終了後にプランが変更となります。</span>
          </div>
          <span>プランはお客様側で変更を行わない限り、自動更新となります。</span>
        </div>
      </div>
      <div class="plan-btn-group">
        <button class="cs-btn-plan cs-btn-change" @click="handleChangePlan">
          <label>決定する</label>
        </button>
        <button class="cs-btn-plan cs-btn-cancel" @click="handleCloseModal">
          <label>キャンセル</label>
        </button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      timezone: ((new Date()).getTimezoneOffset() * -1) / 60,
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    plan: {
      type: Object,
      default: () => {
      },
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit('handleCloseModal');
    },
    async handleChangePlan() {
      this.$root.$refs.loading.start();
      const body = {
        plan_id: this.plan.id,
        timezone: this.timezone,
      };
      const res = await this.$store.dispatch('monthly-plan/actChangeMonthlyPlan', body);
      if (res.response && res.response.status && [400, 409, 404].includes(res.response.status)) {
        this.$emit('error-mfk', res.response.status);
      }
      this.$root.$refs.loading.finish();
      this.handleCloseModal();
      this.$emit('handleGetDataPlan');
    },
  },
};
</script>
<style lang="scss">
.ant-modal-close-icon {
  font-size: 20px;
}
</style>
